import React from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import type { ModalExtraOnlyPackSingleType } from "../../../utils/modalConstants";
import type { ExtraType, ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import CarDataConsolidator from "../../../../../shared-logic/utils/classes/CarDataConsolidator";
import { useBnbSelector } from "../../../redux/store";
import Packs from "../step-customize/main-content/Packs";
import { BnbLabel } from "../../../utils/labels";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import ButtonPrimary from "../../../../../../common-deprecated/components/aem/toyota/ButtonPrimary";

// Modal used when an extra is only available in a pack and the extra is available in multiple packs.
const ExtraOnlyPackMultipleModal = (props: ModalViewType<ModalExtraOnlyPackSingleType>): JSX.Element | null => {
    const { show, close, modalSettings } = props;
    const { extra } = modalSettings;
    const items = useBnbSelector((state) => state.items);

    const packs = CarDataConsolidator.findPackEquipment(extra as ExtraType, items.packs)?.packs;

    const closeLabel = useCommonLabel("close");

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title smallText>
                    <BnbLabel label="extraOnlyPackMultipleModalTitle" params={{ count: packs!.length }} />
                </Modal.Title>
                <Modal.Button type="button" aria-label={closeLabel} onClick={close}>
                    <IconWrapper aria-hidden="true">
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body darkVariant>
                <Packs extra={extra} />
            </Modal.Body>
            <Modal.Actions rightAlignment>
                <ButtonPrimary onClick={close}>
                    <BnbLabel label="extraOnlyPackMultipleModalClose" />
                </ButtonPrimary>
            </Modal.Actions>
        </ModalBaseView>
    );
};

export default ExtraOnlyPackMultipleModal;
